export default __webpack_public_path__ + "static/media/de.c8e11cd9.svg";